import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Footer() {
  const { user } = useAuth();

  return (
    <footer className="w-full border-t border-[#1e251f] py-12 gradient-section-dark" data-testid="footer" role="contentinfo" aria-label="site footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center space-y-6 lg:space-y-0">
          <p className="text-[#555555] lowercase">
            <span className="logo-text">logOS</span> · 2026
          </p>
          <div className="flex flex-wrap gap-6 text-[#555555]">
            <Link to="/" className="lowercase hover:text-white transition-all duration-300">home</Link>
            <Link to="/checkpoints" className="lowercase hover:text-white transition-all duration-300">search</Link>
            <Link to="/about" className="lowercase hover:text-white transition-all duration-300">about</Link>
            <Link to="/chat" className="lowercase hover:text-white transition-all duration-300" data-testid="footer-chat-link">chat</Link>
            <Link to="/paper" className="lowercase hover:text-white transition-all duration-300">paper</Link>
            <Link to="/specs" className="lowercase hover:text-white transition-all duration-300">tech specs</Link>
            <Link to="/downloads" className="lowercase hover:text-white transition-all duration-300" data-testid="footer-downloads-link">downloads</Link>
            <Link to="/info" className="lowercase hover:text-white transition-all duration-300" data-testid="footer-info-link">info</Link>
            {user && user.role === 'admin' && (
              <Link to="/admin" className="lowercase hover:text-white transition-all duration-300" data-testid="footer-admin-link">admin</Link>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
